import { Component, Prop, Ref, Watch } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class RecipientForm extends ThemeComponent {
    @Ref trigger !: HTMLInputElement;
    @Ref recipientForm !: HTMLElement;

    init() {
        this.handleTrigger();
    }

    /**
     * Handle checkbox trigger
     */
    handleTrigger() {
        this.$listen(this.trigger, 'change', () => {
            if (this.trigger.checked) {
                this.recipientForm.classList.remove('hidden');
                return;
            }
            this.recipientForm.classList.add('hidden');
        });
    }
}
